import Hosts from '../../../Hosts';

const object_type = 'formation/course'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
const api_list_route = (companycode) => `${Hosts.SIMCore_API}/${object_type}/${companycode}`

const base_endpoint = '/formation_content'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    list2: `${base_endpoint}_list2`,
    view: `${base_endpoint}_view`,
    gest: `${base_endpoint}_gest`
}

const data_interface = {
    id: '',
    info: {
        companycode: '', 
        name: '',
        date: {
            creation: '',
            begin: '',
            end: '',
            publication: '',
            registration_begin: '',
            registration_deadline: '',
            extension: '',
            modified: []
        }, 
        language: [], 
        media: {
            id: '',
            link: '',
        },  
        seo: {
            title: '',
            description: '',
            keywords: '',
            language: []
        }, 
        type: 'course',
        parent: '0', 
        order: '1',
        slug: '', 
        trainers: [],
        status: 'without_emphasis',
    },
    content: [
        {
            title: '',
            abstract: '',
            text: '',
            observations: '',
            duration: '',
            formation_lang: 'formation_language_pt',
            modality: 'formation_modality_classroom',
            modules: [],
            sessions: '',
            schedule: 'formation_schedule_working_hours',
            start_date: '',
            end_date: '',
            financing: '',
            target: '',
            trainees: [],
            candidates: [],
            price: '',
            vacancies: '',
            media: {
                image: [],
                doc: []
            },
            language: []
        }
    ]
}

export {
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
